import { useState } from 'react';

export const useDataViewer = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openViewer = (data) => {
    setSelectedData(data);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
    setSelectedData(null);
  };

  return {
    isViewerOpen,
    selectedData,
    openViewer,
    closeViewer
  };
};

export default useDataViewer; 